import { generateStripeState } from '../helper'

const options = {
  api: {
    get: () => `/api/stripe/account/owner`,
    create: () => `/api/stripe/account/owner/requirements`
  },
  state: {
    collectionName: 'accountOwners'
  },
  getters: {
    getCollection: 'getAccountOwners'
  },
  actions: {
    get: 'getAccountOwner',
    create: 'updateAccountOwnerRequirements'
  },
  mutationKey: 'ACCOUNT_OWNER',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions
  },
  mutations:{
    ...stripeMutations
  }
}
